import type { PlayerId, TileOwner, UnitKind } from "../engine/types";

export const MAP_TILE_SIZE = 48;

export const PLAYER_COLORS: Record<TileOwner, string> = {
  p1: "#2563eb",
  p2: "#e11d48",
  neutral: "#555555",
};

export const UNIT_COLORS: Record<PlayerId, Record<UnitKind, string>> = {
  p1: {
    rifleman: "#5484ef",
    rpgInfantry: "#2563eb",
    sniper: "#134cca",
    landTransport: "#6b95f1",
    supplyTruck: "#e8b923",
    artillery: "#5484ef",
    lightTank: "#3c74ed",
    antiAir: "#2563eb",
    missiles: "#1555e2",
    rockets: "#134cca",
    heavyTank: "#1043b3",
    transportCopter: "#6b95f1",
    battleCopter: "#3c74ed",
    fighterJet: "#1555e2",
    bomber: "#1043b3",
  },
  p2: {
    rifleman: "#e8496c",
    rpgInfantry: "#e11d48",
    sniper: "#b4173a",
    landTransport: "#eb607e",
    supplyTruck: "#e8b923",
    artillery: "#e8496c",
    lightTank: "#e5335a",
    antiAir: "#e11d48",
    missiles: "#ca1a41",
    rockets: "#b4173a",
    heavyTank: "#9d1432",
    transportCopter: "#eb607e",
    battleCopter: "#e5335a",
    fighterJet: "#ca1a41",
    bomber: "#9d1432",
  },
};
